import { Snackbar, Alert } from '@mui/material'
import { useToastStore } from '@/shared/store/toastStore'

/**
 * Renders active toasts from the toast store.
 * Place once near the root of the app — <Toast /> in App.tsx.
 *
 * Trigger toasts from anywhere via:
 *   useToastStore.getState().show('Saved!', 'success')
 * or in components:
 *   const { show } = useToastStore()
 */
const Toast = () => {
    const { toasts, dismiss } = useToastStore()

    return (
        <>
            {toasts.map((toast, index) => (
                <Snackbar
                    key={toast.id}
                    open
                    autoHideDuration={toast.duration}
                    onClose={() => dismiss(toast.id)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    sx={{ bottom: { xs: 70 + index * 60, md: 24 + index * 60 } }}
                >
                    <Alert
                        severity={toast.severity}
                        onClose={() => dismiss(toast.id)}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {toast.message}
                    </Alert>
                </Snackbar>
            ))}
        </>
    )
}

export default Toast
